import { render } from "./likebutton.vue?vue&type=template&id=1f1cdd27"
import script from "./likebutton.vue?vue&type=script&lang=js"
export * from "./likebutton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__